import { render, staticRenderFns } from "./productType_select.vue?vue&type=template&id=080bbf48&scoped=true"
import script from "./productType_select.vue?vue&type=script&lang=js"
export * from "./productType_select.vue?vue&type=script&lang=js"
import style0 from "./productType_select.vue?vue&type=style&index=0&id=080bbf48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080bbf48",
  null
  
)

export default component.exports